'use strict';

function FormDirtyConfirmDirective($translate) {
  return {
    require: '^form',
    link: function($scope, elem, attrs, formCtrl) {
      // Translations
      var confirmMsg, unsavedMsg;

      confirmMsg = $translate.instant('confirm-form-dirty.question');
      unsavedMsg = $translate.instant('confirm-form-dirty.unsaved');

      function confirmFormDirty(event) {
        if(formCtrl.$dirty && !window.confirm(confirmMsg)) {
          event.preventDefault();
        }
      }

      function windowUnload(event) {
        if(formCtrl.$dirty) {
          (event || window.event).returnValue = unsavedMsg;
          return false;
        }

        return true;
      }
      $scope.$on('$stateChangeStart', confirmFormDirty);
      window.addEventListener('beforeunload', windowUnload, false);

      $scope.$on('$destroy', function() {
        window.removeEventListener('beforeunload', windowUnload, false);
      });
    }
  };
}

angular.module('dokiv')
  .directive('formDirtyConfirm', ['$translate', FormDirtyConfirmDirective]);




//////////////////
// WEBPACK FOOTER
// ./scripts/app/FormDirtyConfirmDirective.js
// module id = 243
// module chunks = 0